import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Tab, Tabs, Box } from '@mui/material';
import CategoryIcon from '@mui/icons-material/Category';
import StraightenIcon from '@mui/icons-material/Straighten';
import ReceiptIcon from '@mui/icons-material/Receipt';
import FactoryIcon from '@mui/icons-material/Factory';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import MedicationIcon from '@mui/icons-material/Medication';
import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout';
import DashboardNavbar from 'examples/Navbars/DashboardNavbar';
import Footer from 'examples/Footer';
import { CategoriesPanel } from './categories';
import { UnitsPanel } from './units';
import { HsnPanel } from './hsnCodes';
import { ManufacturersPanel } from './manufacturers';
import { SuppliersPanel } from './suppliers';
import { ItemsPanel } from './items';

const TEAL = '#00798E';

const TABS = [
  { label: 'Items', icon: <MedicationIcon fontSize="small" /> },
  { label: 'Categories', icon: <CategoryIcon fontSize="small" /> },
  { label: 'Units', icon: <StraightenIcon fontSize="small" /> },
  { label: 'HSN & GST', icon: <ReceiptIcon fontSize="small" /> },
  { label: 'Manufacturers', icon: <FactoryIcon fontSize="small" /> },
  { label: 'Suppliers', icon: <LocalShippingIcon fontSize="small" /> },
];

export default function MMDashboard() {
  const location = useLocation();
  const [tab, setTab] = useState(location.state?.tab ?? 0);

  const panels = [
    <ItemsPanel key="items" />,
    <CategoriesPanel key="categories" />,
    <UnitsPanel key="units" />,
    <HsnPanel key="hsn" />,
    <ManufacturersPanel key="manufacturers" />,
    <SuppliersPanel key="suppliers" />,
  ];

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={3} pb={3}>
        <MDBox px={1} mb={2} display="flex" alignItems="center" gap={1}>
          <MDTypography variant="h5" fontWeight="bold" sx={{ color: TEAL }}>
            Material Management
          </MDTypography>
          <MDTypography variant="body2" color="text" sx={{ opacity: 0.6 }}>
            — Pharmacy
          </MDTypography>
        </MDBox>

        {/* Tab navigation bar */}
        <Box
          sx={{
            bgcolor: 'background.paper',
            borderRadius: '12px',
            boxShadow: '0 2px 16px rgba(0,121,142,0.10)',
            border: '1px solid rgba(0,121,142,0.10)',
            overflow: 'hidden',
          }}
        >
          <Tabs
            value={tab}
            onChange={(_, v) => setTab(v)}
            variant="scrollable"
            scrollButtons="auto"
            TabScrollButtonProps={{ sx: { color: TEAL } }}
            sx={{
              px: 2,
              py: 1,
              '& .MuiTab-root': {
                minHeight: 52,
                fontWeight: 600,
                fontSize: '0.85rem',
                textTransform: 'none',
                color: 'rgba(0,0,0,0.45)',
                px: 3,
                py: 1.5,
                gap: 0.75,
                borderRadius: '10px 10px 0 0',
                transition: 'all 0.18s ease',
                '&:hover': { color: TEAL, bgcolor: 'rgba(0,121,142,0.06)' },
                '&.Mui-selected': { color: TEAL, fontWeight: 700, bgcolor: 'rgba(0,121,142,0.07)' },
              },
              '& .MuiTabs-indicator': {
                backgroundColor: TEAL,
                height: 3,
                borderRadius: '2px 2px 0 0',
              },
            }}
          >
            {TABS.map((t, i) => (
              <Tab key={i} label={t.label} icon={t.icon} iconPosition="start" />
            ))}
          </Tabs>
        </Box>

        {/* Panel content — mt={5} gives 40px - 24px (card mt=-3) = 16px visible gap */}
        <MDBox mt={5}>
          {panels[tab]}
        </MDBox>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}
